import React, { FC } from 'react'

import { paymentPlanFilterOptions } from '@new/__global/components/Filters/Filters.constants'

import { FiltersSharedProps } from './Filters.types'
import { RadioBasedField } from './FiltersVariations/Radio'

interface PaymentPlanFilterProps extends FiltersSharedProps {
  title: string
  onChange: (value?: string) => void
  initialValue?: string
}

export const PaymentPlanFilter: FC<PaymentPlanFilterProps> = ({
  title,
  onChange,
  initialValue,
}) => {
  return (
    <RadioBasedField
      radioGroupId="paymentPlanFilterGroup"
      options={paymentPlanFilterOptions}
      title={title}
      onChange={onChange}
      initialValue={initialValue}
    />
  )
}
